<template>
  <div>
    <v-container>
      <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    </v-container>
    <v-container v-if="loadingSessions">
      <v-row class="d-flex justify-space-between">
        <v-col cols="4">
          <v-skeleton-loader type="heading"></v-skeleton-loader>
        </v-col>
        <v-col cols="4" class="d-flex justify-end">
          <v-skeleton-loader class="pr-2" type="button"></v-skeleton-loader>
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader type="sentences"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-space-between">
        <v-col v-for="i in 6" :key="i" cols="6">
          <v-card shaped>
            <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col>
          <v-card shaped>
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <transition name="slide-fade-down-slow">
      <v-container v-if="!loadingSessions">
        <v-row class="d-flex align-center">
          <v-col class="grow">
            <h1>{{ session.fields.Name }}</h1>
          </v-col>
          <v-col class="shrink">
            <CheckInQRCode :session="session" />
          </v-col>
          <v-col class="shrink">
            <SessionForm
              :session="session"
              title="Edit Session"
              icon="mdi-pencil"
              method="edit"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <p>{{ session.fields.Description }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0" cols="12">
            <SessionInfo :session="session" />
          </v-col>
          <v-col cols="12">
            <AttendeesTable
              :loading="loadingSessions"
              :session="session"
            />
          </v-col>
          <v-col v-if="this.session.fields['Requires Acknowledgement']" cols="12">
            <AcknowledgementsCard
              :loading="loadingSessions"
              :session="session"
            />
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
  import AcknowledgementsCard from '@/components/acknowledgement/Card'
  import AttendeesTable from '@/components/session/AttendeesTable'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import CheckInQRCode from '@/components/session/CheckInQRCode'
  import SessionForm from '@/components/session/Form'
  import SessionInfo from '@/components/session/InfoList'
  
  export default {
    name: 'Session',
    components: {
      AcknowledgementsCard,
      AttendeesTable,
      Breadcrumbs,
      CheckInQRCode,
      SessionForm,
      SessionInfo
    },
    data () {
      return {
        loadingSessions: true
      }
    },
    created () {
      this.$store.dispatch('getRecords', {
        table: 'Sessions',
        view: 'All Sessions',
        dispatch: 'setSessions'
      })
      .then(() => {
        this.loadingSessions = false
      })
    },
    computed: {
      session () {
        return this.$store.getters.getSessions.find(s => {
          return s.id === this.$route.params.id
        })
      },
      breadcrumbs () {
        const curriculumCrumb = {
          text: this.session ? 
                this.session.fields['Curriculum Name'][0] : 
                'Loading...',
          disabled: this.session ? false : true,
          to: {
            name: 'Curriculum',
            params: {
              id: this.session ? this.session.fields.Curriculum[0] : ''
            }
          }
        }
        return [
          {
            text: 'Curriculums',
            disabled: false,
            to: '/'
          },
          curriculumCrumb,
          {
            text: this.session ? this.session.fields.Name : 'Loading...',
            disabled: true
          }
        ]
      }
    }
  }
</script>
